export const NEW_HBS_LOGO = 'https://assets.hbsuk.co.uk/img/platform/HBSUK_Logo_Colour_RGB.svg';
// TODO: Trial using this logo rather than pulling in from the web
export const NEW_HBS_LOGO_SMALL = '/static/images/HBS_new_logo.png';
export const NHS_LOGO = '/static/images/NHS.png';
export const AXA_LOGO = '/static/images/AXA.png';

const HBS_THEME = {
  logo: NEW_HBS_LOGO,
  altText: 'HBS UK logo',
  stylesheet: '/static/hbsuk.css'
};
const NHS_THEME = {
  logo: NHS_LOGO,
  altText: 'NHS logo',
  stylesheet: '/static/nhs.css'
};

const _themes = {
  // HBS
  axa: HBS_THEME,
  hbs: HBS_THEME,
  hbsgast: HBS_THEME,

  // NHS
  aunity: NHS_THEME,
  bob: NHS_THEME,
  demo: NHS_THEME,
  medway: NHS_THEME,

  // OTHER
  dcg: {
    logo: '/static/images/LDC.png',
    altText: 'LDC logo',
    stylesheet: '/static/ldc.css'
  },

  helena: {
    logo: '/static/images/STH.png',
    altText: 'STH logo',
    stylesheet: '/static/sth.css'
  },
  blank: {
    logo: '/static/images/Blank.png',
    altText: 'blank logo',
    stylesheet: '/static/blank.css'
  }
} as const;

type Themes = {
  [K in keyof typeof _themes]: {
    id: K;
    logo?: string;
    altText?: string;
    stylesheet: string;
  };
};

export default Array.from(Object.entries(_themes)).reduce((acc, [key, value]) => {
  acc[key] = {
    id: key,
    ...value
  };
  return acc;
}, {} as Themes);
